<template>
		<div class="course-list">
			<div class="sub-head">
				<div class="course-title">体验课列表</div>
				<div class="course-title back" @click="goBack"> 返回> </div>
			</div>	
			<div class="course-cont">
				<div class="course-card" @click="goDetail(item)" v-for="(item,index) in courseList" :key="index">
					<div class="course-bg" :style="{backgroundImage:`url(${item.coverImg})`}">
					</div>
					<div class="course-name">{{item.point_name}}</div>
					<div class="course-text">{{item.point_info}}</div>
				</div>
			</div>
		</div>
</template>
<script>

export default {
	name: 'index',

	components: {},

	data(){
		return {
			courseList:[
				// {
				// 	coverImg:'https://view.duofenpai.com/image/default/F830D1DAEEF04651AE4095EF54DC6143-6-2.jpg',
				// 	point_name:'勾股定理',
				// 	point_info:'勾股定理7：蚂蚁爬行',
				// 	qf_url:'https://readapi.bluebirdabc.com/lessonplayer/index.html?pid=w7398uoaiIAF98wu&lessonId=381',
				// },
				// {
				// 	coverImg:'https://view.duofenpai.com/image/default/16BD7AA1F1154ED9BC55079D851B3860-6-2.png',
				// 	point_name:'阅读理解题型',
				// 	point_info:'元宝法则：秒杀细节理解题',
				// 	qf_url:'https://readapi.bluebirdabc.com/lessonplayer/index.html?pid=w7398uoaiIAF98wu&lessonId=358',
				// },
				// {
				// 	coverImg:'https://view.duofenpai.com/image/default/3450E085CBE84B58B2A85123AEF0C1ED-6-2.png',
				// 	point_name:'三角函数',
				// 	point_info:'三角函数题型七：三角函数平移变换问题',
				// 	qf_url:'https://readapi.bluebirdabc.com/lessonplayer/index.html?pid=w7398uoaiIAF98wu&lessonId=372',
				// },
				// {
				// 	coverImg:'https://view.duofenpai.com/image/default/16BD7AA1F1154ED9BC55079D851B3860-6-2.png',
				// 	point_name:'文中细节',
				// 	point_info:'阅读理解：元宝法则秒杀细节理解题',
				// 	qf_url:'https://readapi.bluebirdabc.com/lessonplayer/index.html?pid=w7398uoaiIAF98wu&lessonId=380',
				// },
				{
					coverImg:'https://view.duofenpai.com/image/cover/FB9A2AE1F5AE4B21B4AD9C05A913B85E-6-2.png',
					point_name:'初中语法介词',
					point_info:'语法介词:时间介词方法技巧+时间介词真题演练',
					video_url:'https://view.duofenpai.com/e0024a786ad571f0bffc6732b78e0102/2b6cdc7490c549e9aa7f3fe350087b10-f117b89be284e30f94c3a8db98211a26-hd.mp4',
				},
				{
					coverImg:'https://view.duofenpai.com/image/cover/29FBD5337033495E8C744335380AC921-6-2.png',
					point_name:'初中语法数词',
					point_info:'语法数词:数词方法技巧+真题演练',
					video_url:'https://view.duofenpai.com/80ec15296cd271f0bf9b4531959d0102/f90b01dbcb57445f87cb2aaff43c79a4-3c82df07932f8a554c0c5ef5dbb1d0a7-hd.mp4',
				},
				{
					coverImg:'https://view.duofenpai.com/image/cover/D83DAAA8D7B04C139DFED507C70CC078-6-2.png',
					point_name:'初中阅读理解',
					point_info:'阅读理解细节题：元宝词方法技巧＋真题演练',
					video_url:'https://view.duofenpai.com/70e14b6e79ba71f0b1a85017e1f80102/faa2fc1a67f646db89231a7d1ff80534-56e241e6c8a12d5f66f48330d934c6bf-hd.mp4',
				},
				{
					coverImg:'https://view.duofenpai.com/image/cover/91382746B578408BBABEB82EE5B5C939-6-2.png',
					point_name:'高中语法填空',
					point_info:'语法填空:非谓语doing方法技巧+方法技巧真题演练',
					video_url:'https://view.duofenpai.com/109c387ba36471f097226732b78e0102/2c2c17bb72134ad4b682e42a0b6e8d4f-8d6155a47bda3836e380a16d69382d97-hd.mp4',
				},
				{
					coverImg:'https://view.duofenpai.com/image/cover/8D87B523C8604F15A707C5731D5CD10B-6-2.png',
					point_name:'高中阅读理解',
					point_info:'主旨大意题-复现词方法技巧+真题演练',
					video_url:'https://view.duofenpai.com/a0270a1e6acc71f08c7a4531949c0102/ee4168d445fd42a4951aa3e2d4ae6f6f-9b1314786a8ac969dab5754301ae9f37-hd.mp4',
				},
				{
					coverImg:'https://view.duofenpai.com/image/cover/EDCA7899B04D400EB19D1083C75EAC27-6-2.png',
					point_name:'高中阅读理解',
					point_info:'主旨大意题-串读题干方法技巧+真题演练',
					video_url:'https://view.duofenpai.com/c048a4106acc71f0ac856632b68f0102/85819f5131ab42a4acd5872fe96ee5fe-b2b7321ceddc3970b865587df4e56cdc-hd.mp4',
				},
				//数学
				{
					coverImg:'https://view.duofenpai.com/image/cover/717A8A09004149BF9F093DCC72A40A12-6-2.png',
					point_name:'初中勾股定理',
					point_info:'勾股定理：蚂蚁爬行最短距离',
					video_url:'https://view.duofenpai.com/50792ee76cad71f097705017f0f90102/4e46cdd840d7404c96576f2946ce6b1d-5ea12723f7c43f0d846608bfae93ad07-hd.mp4',
				},
				{
					coverImg:'https://view.duofenpai.com/image/cover/818981B0828E49FBAD8A024952CCDA30-6-2.png',
					point_name:'初中二次函数',
					point_info:'二次函数：二次函数与一次函数相交的最值问题',
					video_url:'https://view.duofenpai.com/002730e76cad71f0bfaa5017e1f80102/032a79ba9a3a4cbd8eaaa5502e7a7124-8e0208fcad713f493609f2bc75e2ad47-hd.mp4',
				},
				{
					coverImg:'https://view.duofenpai.com/image/cover/FA13D35BF24B47B285693554B3A16F55-6-2.png',
					point_name:'初中通用技巧',
					point_info:'特值法',
					video_url:'https://view.duofenpai.com/d0cf2ae76cad71f0aa346732b78e0102/b60e9322862b477d925d5c8c039d3530-e9b700ce5c23c3bdcf646a8b096d0b8f-hd.mp4',
				},
				{
					coverImg:'https://view.duofenpai.com/image/default/E86077E97A9742B1B9687043F75430A5-6-2.png',
					point_name:'初中平行四边形',
					point_info:'平行四边形：“十字架”模型',
					video_url:'https://view.duofenpai.com/10e1cd34a3f871f09c984531859c0102/56338b709c1a4b70860a78fc7629746b-31d7db2f29b0ae5f405eb57762ae102f-hd.mp4',
				},
				{
					coverImg:'https://view.duofenpai.com/image/cover/D01E94FF1ECF43B4BF370D1371D0CEA3-6-2.png',
					point_name:'高中三角函数',
					point_info:'三角函数：异名三角函数图象变换问题',
					video_url:'https://view.duofenpai.com/50112df16cad71f08a0c4531958c0102/4e0a8fb4413b424ab0343558b7c2e728-b1ce35e98948802ab5f7614b09b14301-hd.mp4',
				},
				{
					coverImg:'https://view.duofenpai.com/image/cover/C5192E5A454B4F84B6C94453D3AF38A4-6-2.png',
					point_name:'高中解三角形',
					point_info:'解三角形：射影定理',
					video_url:'https://view.duofenpai.com/c0fb31e76cad71f0bfd96632b68f0102/0a2d625cacf4459cad5e0ce228d8a524-af07dd37915a0f26b5de8ae9bc49bcfc-hd.mp4',
				},
				{
					coverImg:'https://view.duofenpai.com/image/cover/59F7C935909946C6AF9061B3BD733FB6-6-2.png',
					point_name:'高中圆锥曲线',
					point_info:'圆锥曲线：已知双曲线离心率或渐近线倾斜角、斜率，求另一个量',
					video_url:'https://view.duofenpai.com/604e7294a4f471f081084531948c0102/d7816a6c11b3462aa5f0a98ed3638672-6741fa89c8f80fcdde2e7b62b08d2d89-hd.mp4',
				},
			],
		}
	},

	created(){

	},
	mounted() {
	},
	beforeDestroy() {
	},

	computed: {

	},
	watch: {

	},
	methods: {
		goDetail(item){
			this.$router.push({  //核心语句
			  path:'/shitingDetail',   //跳转的路径
			  query:{
				  qf_url:item.qf_url,
					video_url:item.video_url,
					name:item.point_info,
			  }
			})
		},
		goBack(){
			this.$router.back()
		}
	}
}
</script>

<style lang="scss" scoped>
.course-list{
	padding: 1.5rem 0 5rem 0.75rem;
	.sub-head{
		margin-bottom: 1.25rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-left: 0.75rem;
		.course-title{
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-weight: 500;
			font-size: 1.6rem;
			color: #000000;
			line-height: 1.7rem;
		}
		.course-more{
			display: flex;
			align-items: center;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-size: 1.2rem;
			color: rgba(0,0,0,0.8);
			line-height: 1.41rem;
			img{
				width: 1.4rem;
				height: 1.4rem;
			}
		}
		.subject{
			display: flex;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-size: 1.4rem;
			color: #000000;
			line-height: 1.64rem;
			margin-right: 1.5rem;
			.tab{
				width: 5.5rem;
				height: 2.5rem;
				line-height: 2.5rem;
				text-align: center;
				border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
				margin-left: 5.8rem;
			}
			.actTab{
				background: rgb(100, 45, 113);
				color: #fff;
			}
		}
	}
	.course-cont{
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		.course-card{
			width: 18.35rem;
			height: 14.45rem;
			background: #FFFFFF;
			border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
			overflow: hidden;
			margin: 0.7rem;
			.course-bg{
				width: 18.35rem;
				height: 7.5rem;
				background-repeat: no-repeat;
				background-size: cover;
				position: relative;
				.course-study{
					position: absolute;
					top: 0.75rem;
					left: 0.75rem;
					width: 4.35rem;
					height: 1.8rem;
					background: rgba(141,51,0,0.77);
					border-radius: 3rem 3rem 3rem 3rem;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 0.8rem;
					color: rgb(100, 45, 113);
					line-height: 1.8rem;
					text-align: center;
				}
				.course-study-end{
					background: #00d215;
					color: #fff;
				}
				.course-ruo{
						position: absolute;
						right: 0;
						top: 0;
						width: 2.45rem;
						height: 2.05rem;
				}
			}
			.course-name{
				margin: 0.75rem 0.9rem 0.6rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 500;
				font-size: 1.1rem;
				color: #1D1D1D;
				line-height: 1.1rem;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				/*! autoprefixer: off */
				-webkit-box-orient: vertical;
			}
			.course-text{
				margin: 0 0.9rem 0.5rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 0.8rem;
				color: #74798C;
				line-height: 1rem;
				height:2rem;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				/*! autoprefixer: off */
				-webkit-box-orient: vertical;

			}
			.course-btn{
				display: flex;
				align-items: center;
				justify-content: flex-start;
				margin: 0 0.9rem;
				.course-avator{
					width: 1.2rem;
					height: 1.2rem;
					border-radius: 6rem;
					margin-right: 0.4rem;
				}
				.course-teacher{
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 0.8rem;
					color: #1D1D1D;
					line-height: 1.12rem;
				}
				.course-save{
					background-image: url('../assets/heart-1.png');
					background-repeat: no-repeat;
					background-size: contain;
					width: 1.2rem;
					height: 1.2rem;
					margin-left: auto;
				}
				.course-save-act{
					background-image: url('../assets/heart.png');
				}
			}
		}
	}
}
.back{
	font-weight: 400!important;
	margin-right: 2rem;
}
// .back{
// 	text-align: center;
// 	width: 4rem;
// 	height: 4rem;
// 	display: flex;
// 	justify-content: center;
// 	align-items: center;
// 	border-radius: 100%;
// 	font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
// 	font-weight: 500;
// 	font-size: 1.6rem;
// 	line-height: 1.88rem;
// 	position: absolute;
// 	bottom: 5rem;
// 	left: 2rem;
// 	z-index: 999;
// 	color: #FFFFFF;
// 	background: rgb(100, 45, 113);
// 	border: 0.2rem solid #E0E0E0;
// }
</style>
